import {constructPartnerBankInfo, constructPartnerDetails} from "../Factory/factory";
import {findPartnerDetails} from "../Util/queries";
import {PARTNER_BANK_INFO} from "../Components/Payouts/bankInfoHolder";
import {REFERRAL_LINK} from "../Reducers/referralLinkReducer";
import { PARTNER_ACTIVE } from "../Reducers/partnerActiveReducer";

const PARTNER_DETAILS = "PARTNER_DETAILS";

export const getPartnerDetails = () =>
    async (dispatch) => {
        try {
            let response = await findPartnerDetails();
            if (response.data) {
                let detailsData = response.data;
                let partnerDetailsObj = constructPartnerDetails(detailsData.partnerId, detailsData.partnerType, detailsData.address, detailsData.billingAddress, detailsData.billingDiscountPercent, detailsData.companyName, detailsData.contactPerson, detailsData.titleOfContactPerson, detailsData.email, detailsData.phoneNumber, detailsData.partnerCode);
                let partnerBankInfoObj = constructPartnerBankInfo(detailsData.accountHolderName, detailsData.routingNumber, detailsData.accountNumber, detailsData.paypal);
                dispatch({
                    type: PARTNER_DETAILS,
                    payload: partnerDetailsObj
                })
                dispatch({
                    type: PARTNER_BANK_INFO,
                    payload: partnerBankInfoObj
                })
                dispatch({
                    type: REFERRAL_LINK,
                    payload: detailsData.invitationLink
                })
                dispatch({
                    type: PARTNER_ACTIVE,
                    payload: {active: detailsData.active},
                })
            } else {
                dispatch({
                    type: PARTNER_DETAILS,
                    payload: null,
                })
            }
        } catch (e) {
            dispatch({
                type: PARTNER_DETAILS,
                payload: null,
            })
        }
    }

export {PARTNER_DETAILS}
